import * as React from "react";
import type { SVGProps } from "react";
const SvgDiscountSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8.4 15.6 7.2-7.2m-6.646.55-.014-.015m6.124 6.188-.014-.015M2.4 19.2V4.8a2.4 2.4 0 0 1 2.4-2.4h14.4a2.4 2.4 0 0 1 2.4 2.4v14.4a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgDiscountSquare;
